import React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import "./Card.scss";
import Button from "../Button/Button.js";
import Note from "../../icons/note.svg";
import Return from "../../icons/return.svg";

import CardNote from "./CardNote";
import CardInfo from "./CardInfo";

import Switch from "../Switch/Switch";

import { campaignDashStat } from "../../utils/urls";

const Card = ({
  card,
  onTakeOnClick,
  onTakeOffClick,
  canTakeOn,
  onSetHidden,
  onSetRatio,
  onSetPacket,
  canTakeOff,
  permissions
}) => {
  const [showNote, setShowNote] = useState(false);

  const toggleNote = () => {
    setShowNote(prevShowNote => {
      return !prevShowNote;
    });
  };

  const onHiddenChange = e => {
    onSetHidden(e.target.checked);
  };

  const isTaken = card.user_id != null;
  const takenBy = card.user_name || "В работе";

  const canChangeHidden = permissions.includes(
    "content3__cards__can_change_hidden"
  );
  const canTakeOffCurator = permissions.includes(
    "content3__cards__can_take_off_curator"
  );

  return (
    <div className="card">
      <div className="card__header">
        <img src={card.favicon} className="card__icon" />
        <a
          className="card__name"
          target="_blank"
          href={campaignDashStat(card.cid)}
        >
          {card.name}
        </a>
        <div className="card__button">
          <Button
            color="light-blue"
            icon={showNote ? Return : Note}
            onClick={toggleNote}
          />
        </div>
      </div>
      {showNote ? (
        <div className="card__body">
          <CardNote note={card.working_notes} />
        </div>
      ) : (
        <React.Fragment>
          <div className="card__body">
            <CardInfo
              card={card}
              onSetRatio={onSetRatio}
              onSetPacket={onSetPacket}
            />
          </div>
          <div className="card__footer">
            <div className="card__taken_by">
              {isTaken ? takenBy : "Не в работе"}
            </div>
            {canChangeHidden && (
              <Switch onChange={onHiddenChange} checked={card.hidden} />
            )}
            <div className="card__take_button">
              {isTaken ? (
                (canTakeOff || canTakeOffCurator) && (
                  <Button color="green" onClick={onTakeOffClick}>
                    Убрать
                  </Button>
                )
              ) : (
                <Button
                  color="blue"
                  onClick={onTakeOnClick}
                  disabled={!canTakeOn || card.debt_percent == 0}
                >
                  Взять
                </Button>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

Card.propTypes = {
  card: PropTypes.object.isRequired,
  onTakeClick: PropTypes.func
};

Card.defaultProps = {
  canTakeOff: true
};

export default Card;
